import { Request, RequestWithToken, POST, GET, PUT, DELETE, PATCH } from './base';

const GetProfile = async () => {
    const checkLiveStatus = !!localStorage.getItem('POLLING_TIME_LEFT') || !!localStorage.getItem('CALL_LIVE_API');
    return await Request('/userdetail' + (checkLiveStatus ? '?check_live_status=true' : ''), GET, true)
};

const GetProfileWithToken = async (token: string) => {
    return await RequestWithToken('/userdetail', GET, token);
};

const GetSuggestedPrompts = async () => await Request('/suggested-prompts', GET, true);

const UpdateVoiceLang = async (payload: any) => await Request('/update-voice-lang', POST, true, payload);

const PingCredit = async () => await Request('/pingcredit', GET, true);

const UpdateVisitedFlag = async (payload: Object) => await Request('/update-welcome-visited', POST, true, payload);

const GetPaymentStatusConfig = async () => {
    return await Request('/api/v1/payment/payment-status', GET, true);
};

const profileRest = {
    GetProfile,
    GetSuggestedPrompts,
    UpdateVoiceLang,
    PingCredit,
    GetProfileWithToken,
    UpdateVisitedFlag,
    GetPaymentStatusConfig,
};

export default profileRest;